import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import util from 'util/Util.js'
import { View } from 'backbone';
import listService      from 'ListService';

import _Template from 'properties/accessibility/silent.ejs';

class NavAccessSilentView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = '#accessibilitySilent';

        this.events = {
            'change input[type=checkbox]' : 'updateCheckboxAttributes'
        };


        return this;
    }

    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        this.model.set( propName, propVal );
        //console.log(`AccessibilityView model.set(${propName}, ${this.model.get( propName )})`);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        let bSilent = util.isTrue(this.model.get('accessSilent'));

        if ( listService.selected.size > 1 ) {            
            setTimeout((e)=>{
                $('div#propAccessSilent').html(this.template(this.model.toJSON()));
                
                $( this.$el[0] ).off().on('click', (evt)=>{
                    
                    if (evt.target.name === 'accessSilent') {
                        this.model.set('accessSilent', evt.target.checked);
                    }
                });
                if (typeof this.model.get('accessSilent') === 'boolean' && this.model.get('accessSilent')) {
                    $(`input[name='accessSilent']`).prop('checked', true );
                }
            },0);

        }
        
        $(`input[name='accessSilent']`).prop('checked', bSilent );

        this.delegateEvents();
        return this;
    }

}

export default NavAccessSilentView;
